/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Use_Viewing_ProtocolInputs */

const cs_templates_use_viewing_protocol = /** @type {(inputs: Templates_Use_Viewing_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použít`)
};

const en_templates_use_viewing_protocol = /** @type {(inputs: Templates_Use_Viewing_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use`)
};

/**
* | output |
* | --- |
* | "Use" |
*
* @param {Templates_Use_Viewing_ProtocolInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_use_viewing_protocol = /** @type {((inputs?: Templates_Use_Viewing_ProtocolInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Use_Viewing_ProtocolInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_use_viewing_protocol(inputs)
	return cs_templates_use_viewing_protocol(inputs)
});